var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" "+_vm._s(_vm.$props.label)+" "),_c('v-otp-input',_vm._b({attrs:{"length":"6","value":_vm.modelValue},on:{"input":(newValue) => (_vm.modelValue = newValue)}},'v-otp-input',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }